import { ChevronRight } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Typography } from '@/components/ui/typography';
import { cn } from '@/lib/utils';
import type { TableState } from '@/types/property.types';
import { TableStateType } from '@/types/property.types';

const stateStyles: Record<string, { bg: string; text: string }> = {
  [TableStateType.ERROR]: {
    bg: 'bg-accent',
    text: 'text-destructive',
  },
  [TableStateType.SUCCESS]: {
    bg: 'bg-success-soft',
    text: 'text-success',
  },
  [TableStateType.NO_ERROR]: {
    bg: 'bg-muted',
    text: 'text-foreground',
  },
};

export function States({ type, text, onClicked }: TableState) {
  if (type !== TableStateType.DEFAULT) {
    const styles = stateStyles[type] ?? stateStyles[TableStateType.ERROR];
    return (
      <span className={cn('inline-flex h-[30px] items-center rounded-sm', styles.bg)}>
        <Typography variant="body" className={cn('px-3 font-medium', styles.text)}>
          {text}
        </Typography>
      </span>
    );
  }

  // Standalone action link: the link variant carries no touch floor by
  // design, so the call site adds it (the convention button.tsx records).
  return (
    <Button
      type="button"
      variant="link"
      onClick={onClicked}
      className="gap-1 text-foreground hover:no-underline max-lg:min-h-11"
    >
      <Typography variant="body" className="font-semibold">
        {text}
      </Typography>
      <ChevronRight className="h-4 w-4 text-foreground" aria-hidden="true" />
    </Button>
  );
}
